export enum QuestionFillBlanksStyle {
    TYPE_IN = 'type_in',
    DRAG_AND_DROP = 'drag_and_drop'
}
